import React, { useContext, useEffect, useState } from 'react'
import {
    Box, Button, Typography, IconButton, CircularProgress,
    Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Paper,
    Divider,
} from '@mui/material';
import Context from '../../context/Context';
const Permissions = () => {
    const { permissions, getPermissions } = useContext(Context)
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState('');

    useEffect(() => {
        getPermissions()
    }, [])

    return (
        <>
            <Box sx={{ backgroundColor: "", padding: 3 }}>

                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                    <Typography variant="h3"> Permissions</Typography>
                </Box>

                <Divider sx={{ mb: 3 }} />

                {loading ? (
                    <Box display="flex" justifyContent="center" alignItems="center" height="100px">
                        <CircularProgress />
                    </Box>
                ) : (
                    <TableContainer component={Paper} elevation={1}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell><strong>S.No</strong></TableCell>
                                    <TableCell><strong>Name</strong></TableCell>
                                    <TableCell><strong>Is Active</strong></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {permissions?.length === 0 ? (
                                    <TableRow>
                                        <TableCell colSpan={4} align="center">
                                            No permissions found.
                                        </TableCell>
                                    </TableRow>
                                ) : (
                                    permissions.map((permissions, index) => (
                                        <TableRow key={permissions.id}>
                                            <TableCell>{index + 1}</TableCell>
                                            <TableCell>{permissions?.name}</TableCell>
                                            <TableCell>{permissions?.isActive === true ? "true" : "false"}</TableCell>
                                        </TableRow>
                                    ))
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}
                {errors && <Typography variant='body2' color='error'>{errors}</Typography>}
            </Box>
        </>
    )
}

export default Permissions